<div class="learner-profile" *ngIf="!isLoading; else shimmer">
    <div
        class="profile-top"
        fxLayout="column"
        fxLayout.gt-md="row"
        fxLayoutAlign="start stretch"
        fxLayoutAlign.gt-md="start center"
        fxLayoutGap.gt-md="24px"
    >
        <div class="profile-identity" fxLayout="row" fxLayoutAlign="start center" fxFlex.gt-md="0 0 auto">
            <div class="relative profile-avatar-wrap">
                <img *ngIf="profile.avatar?.src; else initials" class="avatar profile-avatar" [src]="profile.avatar.src" [alt]="profile.fullName" />
                <ng-template #initials>
                    <div fxLayoutAlign="center center" class="avatar-initials avatar profile-avatar" attr.aria-label="{{ profile.fullName }}">
                        {{ profile.fullName | initials }}
                    </div>
                </ng-template>
            </div>
            <div class="profile-name" fxLayout="column" fxLayoutAlign="center flex-start">
                <label class="profile-name-label text-lightgreytextcolor font-semibold uppercase tracking-[2px]" tabindex="0">{{ 'NAV.MY_LEARNINGS.TITLE' | translate }}</label>
                <span class="profile-name-text text-darktextcolor font-medium" tabindex="0">{{ profile.firstName }}</span>
                <span class="profile-name-text text-darktextcolor font-medium" tabindex="0">{{ profile.lastName }}</span>
            </div>
        </div>
        <div class="profile-panels w-full min-w-0 md:h-220" fxFlex.gt-md="1 1 auto">
            <mat-tab-group animationDuration="0ms">
                <mat-tab tabindex="0" attr.aria-label="{{ 'GENERAL.LABEL.MY_PROGRESS' | translate }}"
                    ><ng-template mat-tab-label>
                        <mat-icon svgIcon="progress"></mat-icon>
                    </ng-template>
                    <div class="p-24 h-full">
                        <div fxLayoutAlign="space-between center" class="mb-16">
                            <label class="text-base" tabindex="0">{{ 'GENERAL.LABEL.STATISTICS' | translate }}</label>
                            <div class="period-tag">
                                <span class="!text-xs font-medium" tabindex="0">{{ 'GENERAL.LABEL.LAST_12_MONTHS' | translate }}</span>
                            </div>
                        </div>
                        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-between center" fxLayoutGap.gt-sm="8px" class="progress-statistics-wrapper">
                            <div fxLayoutAlign="space-between center" class="stat-tile p-16 rounded w-full" fxFlex.gt-sm="24.5%">
                                <span tabindex="0">{{ 'GENERAL.LABEL.NOT_STARTED_COURSES' | translate }}</span>
                                <div class="statistics-counter">
                                    <span tabindex="0">{{ userLearningProgress?.notStartedCourses }}</span>
                                </div>
                            </div>
                            <div fxLayoutAlign="space-between center" class="stat-tile p-16 rounded w-full" fxFlex.gt-sm="24.5%">
                                <span tabindex="0">{{ 'GENERAL.LABEL.IN_PROGRESS_COURSES' | translate }}</span>
                                <div class="statistics-counter">
                                    <span tabindex="0">{{ userLearningProgress?.inProgressCourses }}</span>
                                </div>
                            </div>
                            <div fxLayoutAlign="space-between center" class="stat-tile p-16 rounded w-full" fxFlex.gt-sm="24.5%">
                                <span tabindex="0">{{ 'GENERAL.LABEL.COMPLETED_COURSES' | translate }}</span>
                                <div class="statistics-counter">
                                    <span tabindex="0">{{ userLearningProgress?.completedCourses }}</span>
                                </div>
                            </div>
                            <div fxLayoutAlign="space-between center" class="stat-tile p-16 rounded w-full" fxFlex.gt-sm="24.5%">
                                <span tabindex="0">{{ 'GENERAL.LABEL.TOTAL_LEARNING_TIME' | translate }}</span>
                                <div fxLayoutAlign="flex-end center">
                                    <div class="statistics-counter mr-8">
                                        <span tabindex="0">{{ userLearningProgress?.totalLearningTime }}</span>
                                    </div>
                                    <span class="font-bold text-base text-[#58499D]" tabindex="0">{{ 'GENERAL.LABEL.MINUTES_SHORT' | translate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>

                <mat-tab *ngIf="isToDoFeatureEnabled">
                    <ng-template mat-tab-label>
                        <mat-icon svgIcon="todos"></mat-icon>
                        <span class="block tracking-normal ml-8 text-sm">
                            {{ 'TODOS.TITLE.TO_DOS' | translate }}
                            <span *ngIf="toDoList.totalCountOfOpenToDos">({{ toDoList.totalCountOfOpenToDos }}) </span>
                        </span>
                        <div class="red-dot" *ngIf="toDoList.hasOverdueToDo"></div>
                        <div class="orange-dot" *ngIf="!toDoList.hasOverdueToDo && toDoList.hasNewToDo"></div>
                    </ng-template>

                    <div class="p-24 h-full">
                        <div fxLayoutAlign.gt-md="space-between center" fxLayoutGap.gt-md="16px" class="h-full" *ngIf="toDoList.toDos.length; else noTodos">
                            <div class="w-100-p xl:h-full" fxLayoutAlign.gt-md="flex-start center" fxLayoutGap.gt-md="8px">
                                <div
                                    class="bg-lightgreybackground p-16 pointer lg:h-full mb-4 lg:!mb-0"
                                    fxLayout="column"
                                    fxLayoutAlign="space-between flex-start"
                                    fxFlex.gt-md="0 0 calc(50%-8px)"
                                    [class.bg-red-100]="todo.isOverdue"
                                    *ngFor="let todo of toDoList.toDos.slice(0, 2)"
                                    (click)="navigateByToDoType(todo)"
                                >
                                    <div class="w-100-p" fxLayoutAlign="space-between center">
                                        <h4 class="mb-0 mt-0 mr-4 text-truncate font-medium" tabindex="0">
                                            {{ todo.title }}
                                        </h4>
                                        <div class="new-badge" *ngIf="!todo.isViewedByAssignee">
                                            <span>{{ 'GENERAL.NEW' | translate }}</span>
                                        </div>
                                        <div class="overdue-badge" *ngIf="todo.isOverdue && todo.isViewedByAssignee">
                                            <span>{{ 'GENERAL.LABEL.OVERDUE' | translate }}</span>
                                        </div>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="center flex-start" class="w-full">
                                        <span class="block">
                                            {{
                                                todo.type === ToDoTypeEnum.CERTIFICATE_TO_DO
                                                    ? todo.certificateToDo.certificate?.module?.name
                                                    : todo.type === ToDoTypeEnum.MODULE_TO_DO
                                                    ? todo.moduleToDo.module?.name
                                                    : todo.type === ToDoTypeEnum.SURVEY_TO_DO || todo.type === ToDoTypeEnum.QUIZ_TO_DO
                                                    ? todo.sectionToDo.section.module?.name
                                                    : todo.type === ToDoTypeEnum.PERSONAL_REVIEW_TO_DO
                                                    ? todo.personalReviewToDo.personalReview.type.name
                                                    : todo.type === ToDoTypeEnum.TEAM_REVIEW_TO_DO
                                                    ? todo.teamReviewToDo.teamReview.type.name
                                                    : todo.type === ToDoTypeEnum.APPROVAL_REQUEST_TO_DO
                                                    ? todo.approvalRequestToDo.approvalRequest?.courseName
                                                    : ''
                                            }}
                                        </span>
                                        <span class="text-lightgreytextcolor block" [class.text-red-700]="todo.isOverdue"
                                            >{{ 'GENERAL.PROPERTY.DUE_DATE' | translate }} {{ todo.dueDate | date: 'shortDate' }}</span
                                        >
                                        <div fxLayout="row" fxLayoutAlign="flex-end" class="w-full">
                                            <span class="text-gray-700 text-sm font-medium">{{ todo.type | getToDoAction: todo.moduleToDo?.module.kind | translate }}</span>
                                            <mat-icon>keyboard_arrow_right</mat-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="see-all-wrapper pointer text-primary-500"
                                [class.text-orange-400]="toDoList.hasNotVisibleNewToDo"
                                [class.text-red-600]="toDoList.hasNotVisibleOverdue"
                                fxLayoutAlign="flex-end center"
                                (click)="goToToDos()"
                            >
                                <span>
                                    {{
                                        toDoList.totalCountOfToDosThatRequireAction <= 2
                                            ? ('GENERAL.LABEL.SEE_ALL' | translate)
                                            : toDoList.totalCountOfToDosThatRequireAction - 2 + ' ' + ('GENERAL.LABEL.MORE_TO_CHECK' | translate)
                                    }}
                                </span>
                                <mat-icon>chevron_right</mat-icon>
                            </div>
                        </div>

                        <ng-template #noTodos>
                            <div fxLayout="row" fxLayoutAlign="center center" class="px-16 h-full">
                                <mat-icon class="!w-[67px] !h-[67px]" svgIcon="todos"> </mat-icon>
                                <div fxLayout="column" class="ml-16">
                                    <h2 class="mb-8 mt-0">
                                        {{ 'TODOS.LABEL.NO_OPEN_TODOS' | translate }}
                                    </h2>
                                    <app-white-button [label]="'TODOS.BUTTON.SEE_COMPLETED'" (onClick)="goToToDos()"></app-white-button>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </mat-tab>

                <mat-tab tabindex="0" attr.aria-label="{{ 'CERTIFICATE.PLURAL' | translate }}" *ngIf="isCertificatesTabVisible">
                    <ng-template mat-tab-label>
                        <mat-icon svgIcon="certificate_color"></mat-icon>
                        <span class="tracking-normal block ml-8 text-sm" tabindex="0">
                            {{ 'PAGE.USER_FORM.TAB.CERTIFICATES.TITLE' | translate }}
                            <span *ngIf="certificatesResponse?.totalCount">({{ certificatesResponse?.totalCount }})</span>
                        </span>
                        <div class="orange-dot" *ngIf="certificatesResponse?.newCount"></div>
                    </ng-template>
                    <div class="p-24 h-full">
                        <div fxLayoutAlign.gt-md="space-between center" fxLayoutGap.gt-md="16px" class="h-full" *ngIf="certificates.length; else noCertificates">
                            <div class="w-100-p xl:h-full" fxLayoutAlign.gt-md="flex-start center" fxLayoutGap.gt-md="8px">
                                <div
                                    class="bg-lightgreybackground p-16 pointer lg:h-full mb-4 lg:!mb-0"
                                    fxLayout="column"
                                    fxFlex.gt-md="0 0 calc(50%-8px)"
                                    *ngFor="let certificate of certificates.slice(0, 2)"
                                    tabindex="0"
                                    (click)="openCertificate(certificate)"
                                    (keydown.enter)="openCertificate(certificate)"
                                >
                                    <div class="mb-8 w-100-p" fxLayoutAlign="space-between center">
                                        <h4 class="mb-0 mt-0 mr-4 text-truncate font-medium" tabindex="0">
                                            {{
                                                certificate.type === CertificateType.ATTENDANCE
                                                    ? certificate.moduleUser.module.name
                                                    : certificate.type === CertificateType.GRADEBOOK
                                                    ? certificate.finalGrade.moduleName
                                                    : certificate.name
                                            }}
                                        </h4>
                                        <div class="new-badge" *ngIf="!certificate.isViewedByOwner">
                                            <span tabindex="0">{{ 'GENERAL.NEW' | translate }}</span>
                                        </div>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="center flex-start">
                                        <span class="block mb-4" tabindex="0">{{ certificate.name }}</span>
                                        <div>
                                            <span
                                                class="text-lightgreytextcolor"
                                                tabindex="0"
                                                *ngIf="
                                                    certificate.type === CertificateType.ATTENDANCE ||
                                                        certificate.type === CertificateType.GRADEBOOK ||
                                                        certificate.type === CertificateType.EXTERNAL_COURSE_CONFIRMATION;
                                                    else certificationRange
                                                "
                                                >{{ certificate.createdAt | date: 'shortDate' }}</span
                                            >
                                            <ng-template #certificationRange>
                                                <div fxLayoutAlign="flex-start center">
                                                    <span class="text-lightgreytextcolor" tabindex="0">{{
                                                        certificate.officialCertificateMetadata.issueDate | date: 'shortDate'
                                                    }}</span>
                                                    &nbsp; - &nbsp;
                                                    <span [style.color]="certificate.officialCertificateMetadata.expirationDate | certificationExpirationColor" tabindex="0">{{
                                                        certificate.officialCertificateMetadata.expirationDate | date: 'shortDate'
                                                    }}</span>
                                                    <mat-icon
                                                        class="ml-4 icon-20"
                                                        tabindex="0"
                                                        [svgIcon]="certificate.officialCertificateMetadata.expirationDate | certificationExpirationIcon"
                                                    ></mat-icon>
                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="see-all-wrapper pointer text-primary-700"
                                fxLayoutAlign="flex-end center"
                                (click)="goToCertificates()"
                                (keydown.enter)="goToCertificates()"
                            >
                                <span tabindex="0">{{
                                    certificatesResponse.totalCountRequireAction <= 2
                                        ? ('GENERAL.LABEL.SEE_ALL' | translate)
                                        : certificatesResponse.totalCountRequireAction - 2 + ' ' + ('GENERAL.LABEL.MORE_TO_CHECK' | translate)
                                }}</span>
                                <mat-icon>chevron_right</mat-icon>
                            </div>
                        </div>
                        <ng-template #noCertificates>
                            <div fxLayout="row" fxLayoutAlign="center center" class="px-16 h-full">
                                <mat-icon class="!w-[67px] !h-[67px]" svgIcon="certificate_color"> </mat-icon>
                                <div class="ml-16" fxLayout="column" fxLayoutAlign="center flex-start">
                                    <h2 class="mb-8 mt-0" tabindex="0">
                                        {{ 'CERTIFICATE.LABEL.NO_CERTIFICATE' | translate }}
                                    </h2>
                                    <app-white-button
                                        [label]="'CERTIFICATE.BUTTON.MANAGE_CERTIFICATES' | translate"
                                        (onClick)="goToCertificates()"
                                        (keydown.enter)="goToCertificates()"
                                    ></app-white-button>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </mat-tab>
                <mat-tab tabindex="0" attr.aria-label="{{ 'EVENT.PLURAL' | translate }}" *ngIf="isEventsTabVisible">
                    <ng-template mat-tab-label>
                        <mat-icon svgIcon="calendar_color"></mat-icon>
                        <span class="tracking-normal block ml-8 text-sm" tabindex="0">
                            {{ 'EVENT.PLURAL' | translate }}
                            <span *ngIf="eventsResponse?.totalCount"> ({{ eventsResponse?.totalCount }}) </span>
                        </span>
                    </ng-template>
                    <div class="p-24 h-full w-full">
                        <div fxLayoutAlign.gt-md="space-between center" fxLayoutGap.gt-md="16px" class="h-full" *ngIf="events.length; else noEvents">
                            <div class="w-100-p xl:h-full" fxLayoutAlign.gt-md="flex-start center" fxLayoutGap.gt-md="8px">
                                <div
                                    class="bg-lightgreybackground p-16 pr-44 pointer lg:h-full mb-4 lg:!mb-0"
                                    [class.pointer]="event.type === 'module' || (event.type === 'public' && isGlobalCalendarFeatureEnabled)"
                                    fxLayout="column"
                                    *ngFor="let event of events"
                                    tabindex="0"
                                    fxFlex.gt-md="0 0 calc(50%-8px)"
                                    (click)="event.type === 'module' || (event.type === 'public' && isGlobalCalendarFeatureEnabled) ? goToEvent(event) : null"
                                    (keydown.enter)="event.type === 'module' || (event.type === 'public' && isGlobalCalendarFeatureEnabled) ? goToEvent(event) : null"
                                >
                                    <h4 class="mb-0 mt-0 mr-4 text-truncate font-medium" tabindex="0">{{ event.type === 'public' ? event.name : event.module.name }}</h4>
                                    <div fxLayout="column" fxLayoutAlign="center flex-start">
                                        <span class="block mb-4" tabindex="0">{{
                                            event.type === 'public' ? ('PAGE.CALENDAR.PROPERTY.PUBLIC_EVENT' | translate) : event.name
                                        }}</span>
                                        <span class="text-lightgreytextcolor" tabindex="0"
                                            >{{ event.start | date: 'short' }} - {{ event.end | date: 'short' }} {{ event.location?.name ? ', ' : '' }}
                                            {{ event.location?.name }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                            <div
                                class="see-all-wrapper text-primary-700 pointer"
                                fxLayoutAlign="flex-end center"
                                (click)="goToEvent()"
                                (keydown.enter)="goToEvent()"
                            >
                                <span tabindex="0">{{ 'GENERAL.LABEL.SEE_ALL' | translate }}</span>
                                <mat-icon>chevron_right</mat-icon>
                            </div>
                        </div>
                        <ng-template #noEvents>
                            <div fxLayout="row" fxLayoutAlign="center center" class="px-16 h-full">
                                <mat-icon class="!w-[67px] !h-[67px]" svgIcon="calendar_color"> </mat-icon>
                                <h2 class="ml-16 mb-0 mt-0" tabindex="0">
                                    {{ 'EVENT.NO_UPCOMING_EVENTS' | translate }}
                                </h2>
                            </div>
                        </ng-template>
                    </div>
                </mat-tab>
                <mat-tab tabindex="0" attr.aria-label="{{ 'PAGE.SETTINGS.TAB.APPROVAL_REQUEST.TITLE' | translate }}" *ngIf="isTrainingApprovalRequestFeatureEnabled"
                    ><ng-template mat-tab-label>
                        <mat-icon svgIcon="approval_request_color"></mat-icon>
                        <span class="tracking-normal block ml-8 text-sm" tabindex="0">
                            {{ 'NAV.TRAINING_APPROVAL_REQUESTS.TITLE' | translate }}
                            <span *ngIf="trainingApprovalRequestsResponse?.activeCount">({{ trainingApprovalRequestsResponse?.activeCount }})</span>
                        </span>
                    </ng-template>
                    <div class="p-24 h-full w-full">
                        <div
                            fxLayoutAlign.gt-md="space-between center"
                            fxLayoutGap.gt-md="16px"
                            class="h-full"
                            *ngIf="trainingApprovalRequests.length; else noTrainingApprovalRequests"
                        >
                            <div class="w-100-p xl:h-full" fxLayoutAlign.gt-md="flex-start center" fxLayoutGap.gt-md="8px">
                                <div
                                    class="bg-lightgreybackground p-16 pointer lg:h-full mb-4 lg:!mb-0"
                                    fxLayout="column"
                                    fxLayoutAlign="center flex-start"
                                    fxFlex.gt-md="0 0 48%"
                                    *ngFor="let request of trainingApprovalRequests.slice(0, 2)"
                                    tabindex="0"
                                    (click)="openApprovalRequest(request)"
                                >
                                    <div class="mb-8 w-100-p" fxLayoutAlign="space-between center">
                                        <h3 class="mb-0 mt-0 font-bold" tabindex="0">{{ request.courseProvider }}: {{ request.courseName }}</h3>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="center flex-start">
                                        <span class="block mb-4" tabindex="0"> {{ request.status | getStatus: TrainingApprovalRequestStatus:'translationLabel' | translate }}</span>

                                        <div>
                                            <span class="text-lightgreytextcolor" tabindex="0">{{ 'GENERAL.PROPERTY.LAST_UPDATE' | translate }} </span>
                                            <span class="text-lightgreytextcolor" tabindex="0"> {{ request.updatedAt | date: 'shortDate' }} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="see-all-wrapper pointer" fxLayoutAlign="flex-end center" (click)="goToApprovalRequests()" (keydown.enter)="goToApprovalRequests()">
                                <span tabindex="0">{{ 'GENERAL.LABEL.SEE_ALL' | translate }}</span>
                                <mat-icon svgIcon="right_chevron"></mat-icon>
                            </div>
                        </div>
                        <ng-template #noTrainingApprovalRequests>
                            <div fxLayout="row" fxLayoutAlign="center center" class="px-16 h-full">
                                <mat-icon class="!w-[67px] !h-[67px]" svgIcon="approval_request_color"> </mat-icon>
                                <div class="ml-16" fxLayout="column" fxLayoutAlign="center flex-start">
                                    <h2 class="mb-8 mt-0" tabindex="0">
                                        {{ 'TRAINING_APPROVAL_REQUEST.MESSAGE.NO_REQUEST_YET' | translate }}
                                    </h2>
                                    <app-white-button
                                        [label]="'TRAINING_APPROVAL_REQUEST.BUTTON.SEE_ALL' | translate"
                                        (onClick)="goToApprovalRequests()"
                                        (keydown.enter)="goToApprovalRequests()"
                                    ></app-white-button>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </mat-tab>

                <mat-tab *ngIf="isPerformanceFeedbackFormFeatureEnabled">
                    <ng-template mat-tab-label>
                        <mat-icon svgIcon="performance_review_tile"></mat-icon>
                        <span class="block ml-8 text-sm">
                            {{ 'PERFORMANCE_REVIEW.NAV.PERFORMANCE_REVIEWS' | translate }}
                            <span *ngIf="performanceReviewDoList.countOfActiveReviews"> ({{ performanceReviewDoList.countOfActiveReviews }}) </span>
                        </span>

                        <div class="red-dot" *ngIf="performanceReviewDoList.hasOverdueReview"></div>
                        <div class="orange-dot" *ngIf="!performanceReviewDoList.hasOverdueReview && performanceReviewDoList.hasNotViewedReview"></div>
                    </ng-template>

                    <div class="p-24 h-full">
                        <div fxLayoutAlign.gt-md="space-between center" fxLayoutGap.gt-md="16px" class="h-full" *ngIf="performanceReviewDoList.reviews.length; else noReviews">
                            <div class="w-100-p xl:h-full" fxLayoutAlign.gt-md="flex-start center" fxLayoutGap.gt-md="8px">
                                <div
                                    class="bg-lightgreybackground p-16 pointer lg:h-full mb-4 lg:!mb-0"
                                    fxLayout="column"
                                    fxLayoutAlign="space-between flex-start"
                                    fxFlex.gt-md="0 0 calc(50%-8px)"
                                    [class.bg-red-100]="review.isOverdue"
                                    *ngFor="let review of performanceReviewDoList.reviews.slice(0, 2)"
                                    (click)="navigateToPerformanceReview(review.id)"
                                >
                                    <div class="w-100-p" fxLayoutAlign="space-between center">
                                        <h4 class="mb-0 mt-0 mr-4 text-truncate font-medium" tabindex="0">
                                            {{ review.name }}
                                        </h4>

                                        <div fxLayout="row" fxLayoutAlign="flex-end center">
                                            <div class="new-badge mr-4" *ngIf="!review.isViewedByOwner">
                                                <span>{{ 'GENERAL.NEW' | translate }}</span>
                                            </div>

                                            <div class="overdue-badge mr-4" *ngIf="review.isOverdue && review.isViewedByOwner">
                                                <span>{{ 'GENERAL.LABEL.OVERDUE' | translate }}</span>
                                            </div>

                                            <div
                                                fxLayout="row"
                                                fxLayoutAlign="flex-start center"
                                                class="py-4 px-12 text-truncate uppercase rounded-full tracking-wider text-xs font-medium"
                                                [style.color]="review.status | getStatus: performancePersonalReviewStatus:'color'"
                                                [style.background-color]="review.status | getStatus: performancePersonalReviewStatus:'bgColor'"
                                            >
                                                <span> {{ review.status | getStatus: performancePersonalReviewStatus:'translationLabel' | translate }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div fxLayout="column" fxLayoutAlign="center flex-start" class="w-full">
                                        <span class="block">
                                            {{ review.team?.name }}
                                        </span>

                                        <span class="block">
                                            {{ review.type?.name }}
                                        </span>

                                        <span class="text-lightgreytextcolor block" [class.text-red-700]="review.isOverdue">
                                            {{ 'GENERAL.PROPERTY.DUE_DATE' | translate }} {{ review.dueDate | date: 'shortDate' }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="see-all-wrapper pointer text-primary-500"
                                [class.text-orange-400]="performanceReviewDoList.hasNotVisibleNotViewedReview"
                                [class.text-red-600]="performanceReviewDoList.hasNotVisibleOverdueReview"
                                fxLayoutAlign="flex-end center"
                                (click)="goToPerformanceReviews()"
                            >
                                <span>
                                    {{
                                        performanceReviewDoList.countOfActiveReviews <= 2
                                            ? ('GENERAL.LABEL.SEE_ALL' | translate)
                                            : performanceReviewDoList.countOfActiveReviews - 2 + ' ' + ('GENERAL.LABEL.MORE_TO_CHECK' | translate)
                                    }}
                                </span>
                                <mat-icon>chevron_right</mat-icon>
                            </div>
                        </div>

                        <ng-template #noReviews>
                            <div fxLayout="row" fxLayoutAlign="center center" class="px-16 h-full">
                                <mat-icon class="!w-[67px] !h-[67px]" svgIcon="performance_review_tile"> </mat-icon>
                                <div fxLayout="column" class="ml-16">
                                    <h2 class="mb-8 mt-0">
                                        {{ 'PERFORMANCE_REVIEWS.LABEL.NO_OPEN_REVIEWS' | translate }}
                                    </h2>

                                    <app-white-button [label]="'PERFORMANCE_REVIEWS.BUTTON.SEE_COMPLETED'" (onClick)="goToPerformanceReviews()"> </app-white-button>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>

<ng-template #shimmer>
    <div class="shimmer-container p-0" fxLayout="row wrap" fxLayoutAlign="flex-start space-between" fxLayoutGap="8px grid">
        <div class="shimmer mb-56 w-100-p">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div class="shimmer-card animate mb-8" fxLayout="row" fxLayoutAlign="flex-start space-between" fxFlex="1 0 calc(15%)"></div>
                <div class="shimmer-card animate mb-8" fxLayout="row" fxLayoutAlign="flex-start space-between" fxFlex="1 0 calc(60%)"></div>
            </div>
        </div>
    </div>
</ng-template>
